// extracted by css-extract-rspack-plugin
export default {"cls1":"Configuration-cls1_R1N","cls2":"Configuration-cls2_otH Configuration-cls1_R1N"};